export default function ChampionTitle({ name }) {
  return <div className="champion-card__title">{name}</div>
}
